import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'platform',
})
export class PermissionsService {
  public hasPermission(permissions: string[] | null | undefined, permissionName: string): boolean {
    return permissions?.includes(permissionName) || false
  }

}
